import { useState, useEffect } from 'react';
import GenericPdfStructure from "./GenericPdfStructure";
import GenericPdfDownloader from "./GenericPdfDownloader";

import { getGenericPdfPCData } from "../../utils/ParserUtilities";
import { formatDateWhitoutHour } from "../../utils/formatter";

import "../../styles/genericPDF.css";

const GenericPdfPC = () => {
    const [jobData, setJobData] = useState(null);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        let urlParts = window.location.href.split('generic-pdf-pc/');
        let jobDataId = urlParts[1];
        if (!jobDataId) {
            console.error("No jobDataId found in URL.");
            setJobData({});
            return;
        }

        let newJobData = await getGenericPdfPCData(jobDataId);

        // Limitar el número de imágenes
        if (newJobData?.serviceImagesAfter?.length > 3) {
            newJobData.serviceImagesAfter = newJobData.serviceImagesAfter.slice(0, 3);
        }
        if (newJobData?.serviceImagesBefore?.length > 3) {
            newJobData.serviceImagesBefore = newJobData.serviceImagesBefore.slice(0, 3);
        }
        let allText = ""
        let allItems
        if (newJobData?.includes?.length > 0) {
            newJobData.includes.map((include, index) => {
                if (allText.length < 630) {
                    allText = allText.concat(include)
                    allItems = index
                }
            })
        }
        newJobData.includes = newJobData.includes.slice(0, allItems + 1);
        newJobData.includes.push("....")
        allItems = 0
        allText = ""
        if (newJobData?.doesntIncludes?.length > 0) {
            newJobData.doesntIncludes.map((notInclude, index) => {
                if (allText.length < 630) {
                    allText = allText.concat(notInclude)
                    allItems = index
                }
            })
        }
        newJobData.doesntIncludes = newJobData.doesntIncludes.slice(0, allItems + 1);
        newJobData.doesntIncludes.push("....")

        if (newJobData.business && typeof newJobData.business.url === 'function') {
            try {
                const toDataURL = url => fetch(url)
                    .then(response => response.blob())
                    .then(blob => new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onloadend = () => resolve(reader.result);
                        reader.onerror = reject;
                        reader.readAsDataURL(blob);
                    }));

                newJobData.business = await toDataURL(newJobData.business.url());
            } catch (error) {
                console.error("Error converting business logo to Data URL:", error);
                newJobData.business = null;
            }
        }
        setJobData(newJobData);
    };

    return (
        <div className='pdflm-wrapper'>
            {jobData && jobData.ID ? (
                <>
                    <GenericPdfDownloader
                        document={<GenericPdfStructure jobData={jobData} formatDateWhitoutHour={formatDateWhitoutHour} />}
                        fileName={`Albaran_${jobData.ID}.pdf`}
                    />

                    <div id="testId" className='generic-pdf'>
                        {/* { #header} */}
                        <>
                            <div className='lm-images-wrapper'>
                                <img className='generic-pdf-wolly-logo' src={require("../../assets/wolly-logo-billing.png")} />
                                {
                                    jobData.business && (
                                        <img className='generic-pdf-generic-logo' src={ typeof jobData?.business == "string" ? jobData?.business:jobData?.business.url()} />
                                    )
                                }
                            </div>
                        </>
                        {/* {#ref} */}
                        <>
                            <div className='generic-pdf-boxes-wrapper'>
                                <div className='generic-pdf-little-box bold'>
                                    <p>ID del Presupuesto</p>
                                </div>
                                <div className='generic-pdf-little-box'>
                                    <p>{jobData.ID ? jobData.ID : ""}</p>
                                </div>
                                <div className='generic-pdf-little-box bold'>
                                    <p>Fecha de emisión</p>
                                </div>
                                <div className='generic-pdf-little-box '>
                                    <p>{jobData.createdAt ? formatDateWhitoutHour(jobData.createdAt.toString()) : ""}</p>
                                </div>
                            </div>
                        </>
                        {/* { #cliente} */}
                        <>
                            <div className='generic-pdf-box-title-wrapper'>
                                <p className='generic-pdf-box-title'>Datos del cliente</p>
                            </div>
                            <div className='generic-pdf-boxes-wrapper'>
                                <div className='generic-pdf-little-box bold'>
                                    <p>Nombre</p>
                                </div>
                                <div className='generic-pdf-little-box'>
                                    <p>{jobData.clientName ? jobData.clientName : ""}</p>
                                </div>
                                <div className='generic-pdf-little-box bold'>
                                    <p>Teléfono</p>
                                </div>
                                <div className='generic-pdf-little-box '>
                                    <p>{jobData.clientPhone ? jobData.clientPhone : ""}</p>
                                </div>
                            </div>
                            <div className='generic-pdf-boxes-wrapper'>
                                <div className='generic-pdf-little-box bold'>
                                    <p>Dirección del servicio</p>
                                </div>
                                <div className='generic-pdf-75-box '>
                                    <p>{jobData.jobAddress ? jobData.jobAddress : ""}</p>
                                </div>
                            </div>
                        </>
                        {/* {#servicio} */}
                        <>
                            <div className='generic-pdf-box-title-wrapper'>
                                <p className='generic-pdf-box-title'>Datos del servicio</p>
                            </div>
                            <div className='generic-pdf-boxes-wrapper'>
                                <div className='generic-pdf-little-box bold'>
                                    <p>Gremio</p>
                                </div>
                                <div className='generic-pdf-75-box '>
                                    <p>{jobData.verticalName ? jobData.verticalName : ""}</p>
                                </div>
                            </div>
                            <div className='generic-pdf-boxes-wrapper'>
                                <div className='generic-pdf-little-box bold'>
                                    <p>Descripción</p>
                                </div>
                                <div className='generic-pdf-75-box '>
                                    <p>{jobData.jobDescription ? jobData.jobDescription : ""}</p>
                                </div>
                            </div>
                            {/* {#include} */}
                            <div className='generic-pdf-boxes-wrapper'>
                                <div className='generic-pdf-little-box bold'>
                                    <p>El servicio básico incluye:</p>
                                </div>
                                <div className='generic-pdf-75-box '>
                                    {
                                        jobData?.includes?.map((include, key) => (
                                            <p key={key + " includes"} className='generic-pdf-includes-p'>- {include}</p>
                                        ))
                                    }
                                    <p className='generic-pdf-includes-p'>Para mas informacion relacionada a las inclusiones contacte con Wolly</p>
                                </div>
                            </div>
                            <div className='generic-pdf-boxes-wrapper'>
                                <div className='generic-pdf-little-box bold'>
                                    <p>El servicio básico NO incluye:</p>

                                </div>
                                <div className='generic-pdf-75-box '>
                                    {
                                        jobData?.doesntIncludes?.map((doesntIncludes, key) => (
                                            <p key={key + " doesntIncludes"} className='generic-pdf-includes-p'>- {doesntIncludes}</p>
                                        ))
                                    }
                                    <p className='generic-pdf-includes-p'>Para mas informacion relacionada a las exclusiones contacte con Wolly</p>
                                </div>
                            </div>
                        </>
                        {/* {#firmas} */}
                        <>
                            <div className='generic-pdf-box-title-wrapper noBorders'>
                            </div>
                            <div className='generic-pdf-boxes-wrapper noBorders'>
                                <div className='generic-pdf-medium-box signature bold noBorders'>
                                    {
                                        jobData?.signatures?.signature != "" && (
                                            <img className='generic-pdf-signature' src={jobData?.signatures?.signature} />
                                        )
                                    }
                                </div>
                                <div className='generic-pdf-medium-box signature  bold noBorders'>
                                    {
                                        jobData?.signatures?.signaturePro != "" && (
                                            <img className='generic-pdf-signature' src={jobData?.signatures?.signaturePro} />
                                        )
                                    }
                                </div>
                            </div>
                            <div className='generic-pdf-boxes-wrapper noBorders'>
                                <div className='generic-pdf-medium-box bold noBorders'>
                                    <p>Firma del cliente:</p>
                                </div>
                                <div className='generic-pdf-medium-box  bold noBorders'>
                                    <p>Firma del profesional:</p>
                                </div>
                            </div>
                        </>
                        {/* {#anexos} */}
                        <>
                            <div className='generic-pdf-box-title-wrapper'>
                                <p className='generic-pdf-box-title'>Documentacion Anexa </p>
                            </div>
                            <div className='generic-pdf-boxes-wrapper'>
                                <div className='generic-pdf-full-box  bold'>
                                    <p>Antes (Woller)</p>
                                </div>
                            </div>
                            <div className='generic-pdf-boxes-wrapper'>
                                <div className='generic-pdf-full-box evidence  bold'>
                                    {jobData?.serviceImagesBefore?.map((image, key) =>
                                        (<img key={key + "serviceImagesBefore"} className='generic-pdf-evidence' src={image.base64} />)
                                    )}
                                </div>
                            </div>
                            <div className='generic-pdf-boxes-wrapper'>
                                <div className='generic-pdf-full-box  bold'>
                                    <p>Despues (Woller)</p>
                                </div>
                            </div>
                            <div className='generic-pdf-boxes-wrapper'>
                                <div className='generic-pdf-full-box evidence  bold'>
                                    {jobData?.serviceImagesAfter?.map((image, key) =>
                                        (<img key={key + "serviceImagesAfter"} className='generic-pdf-evidence' src={image.base64} />)
                                    )}
                                </div>
                            </div>
                            <div className='generic-pdf-boxes-wrapper'>
                                <div className='generic-pdf-full-box  bold'>
                                    <p>Anotaciones</p>
                                </div>
                            </div>
                            <div className='generic-pdf-boxes-wrapper'>
                                <div className="generic-pdf-full-box noteBox  bold">
                                    {jobData?.notes}
                                </div>
                            </div>
                        </>
                    </div>
                </>
            ) : (
                <p>Cargando datos del presupuesto...</p>
            )}
        </div>
    )
}

export default GenericPdfPC;